<template>
  <div class="textmessage">
    <div class="con">
      <div class="left-tree">
        <el-scrollbar style="height:100%;width: 100%;">
          <el-tree class="filter-tree" :data="dataList" :expand-on-click-node="true" node-key="id" :props="defaultProps"
            :highlight-current='true' @node-click="nodeClick" ref="tree">
            <template #default="{ node }">
              <span class="custom-tree-node">
                <img src="../../../public/static/image/elTree/2.0.png" v-if="node.data.id == '0000'">
                <img src="../../../public/static/image/elTree/2.2.png" v-else>
                <span style="margin-left:4px">{{ node.label }}</span>
              </span>
            </template>
          </el-tree>
          <!-- myrecordleft-active -->
          <div :class="['myrecordleft',{'myrecordleft-active':isShow == 2}]" @click="getrecord"><img
              src="../../../public/static/image/elTree/2.0.png">消息记录</div>
        </el-scrollbar>
      </div>
      <div class="middle" v-show="isShow == 1">
        <div class="mysend">
          <div class="recipient mydisflex">
            <span class="myname">收件人：</span> <el-input v-model="recipient" clearable placeholder="收件人"></el-input>
          </div>
          <div class="text">
            <p class="myname mynamesss">正<span>文：</span></p>
            <div class="text-con"></div>
          </div>
          <div class="fasong">
            <div class="loginText flexStart">
              <img src="../../../public/static/image/elTree/code.png" /><input type="text" v-model="seccode"
                placeholder="请输入验证码" style="width: 150px" />
              <valid-code ref="validCode"></valid-code>
            </div>
            <el-button type="primary" @click="savemessage" class="search-btn last-el-button" :disabled='btnFlag'>发送
              <span v-show="btnFlag">({{mynum}})</span></el-button>
          </div>
        </div>

      </div>
      <div class="middle2" v-show="isShow == 2">
        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <div class="input-small">
                <span>手机号：</span>
                <el-input v-model="myphone" clearable placeholder="手机号"></el-input>
              </div>
              <el-button type="primary" plain @click="getrecordList" class="search-btn">查询</el-button>
            </div>
          </el-scrollbar>

        </div>
        <div class="myrecord">
          <el-table :data="tableData" style="width: 100%" border stripe :height="heights">
            <el-table-column label="序号" width="60" align="center">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" width="150"> </el-table-column>
            <el-table-column prop="content" label="内容"> </el-table-column>
            <el-table-column prop="createUser" label="发送人" width="150"></el-table-column>
            <el-table-column label="发送时间" width="180" align="center">
              <template slot-scope="scope"><span>{{ scope.row.createTime | date_format}}</span></template>
            </el-table-column>
          </el-table>
        </div>
        <div class="divider-line"></div>
        <div class="paging">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            background :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
      <div class="right-table" v-show="isShow == 1">
        <el-table :data="tableDataPhone" style="width: 100%" border stripe @row-click="handleSelectionChange">
          <el-table-column label="序号" width="60" align="center">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="常用收件人"> </el-table-column>

        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import {magsFindModel,magsFindMagsRecord,magssend,magsfindPhone} from "../../api/loadPower";
  import validCode from '@/components/module/code/validCode.vue'
  export default {
    components: {
      validCode,
    },
    data () {
      return {
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        loading: false,
        recipient: "",
        timers: "",
        deviceName: "",
        defaultExpanded: [],
        dataList: [
          {
            children: [],
            title: '消息发送',
            id: "0000"
          }
        ],
        tableData: [],
        isShow: 1,
        nowMidll: {},
        tableDataPhone: [],
        multipleSelection: [],
        myarr: [],
        heights: Math.round((document.getElementById('app').clientHeight)*0.73),
        myphone: "",
        pageIndex: 1,
        pageSize: 15,
        total: 0,
        textarea: "",
        contentHtml: "",
        mynewArrss: [],
        seccode: "",
        codelist: '',
        mynum: 5,
        mysetInterval: null,
        btnFlag: false
      };
    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      }

    },
    watch: {
      unitId () {
        this.getList()
        this.getrecordList()
      },
      mynum (val) {
        if(val==0) {
          this.btnFlag=false
          clearInterval(this.mysetInterval);
          this.mynum=5
        }
      }

    },

    mounted () {
      this.code()
      this.contentHtml=document.querySelector('.text-con')
      this.$nextTick(() => {
        //默认选中
        this.$refs['tree'].setCurrentKey("0000");
      })

      this.getList()
      this.getrecordList()
    },

    methods: {
      code () {
        this.codelist=''
        var codes=this.$refs.validCode.codeList
        for(let i=0;i<codes.length;i++) {
          this.codelist=this.codelist+codes[i].code
        }
      },

      //获取模板
      getList () {
        magsFindModel({'unitId': this.unitId.id}).then(res => {
          if(res.code==200) {
            this.dataList[0].children=res.data
          }

        })
        this.getPhone()
      },
      //获取手机号
      getPhone () {
        var d={
          'unitId': this.unitId.id
        }
        magsfindPhone(d).then(dat => {
          var mynewarr=[]
          dat.data.forEach(item => {
            mynewarr.push({
              'phone': item
            })
          })
          this.tableDataPhone=mynewarr
        })
      },

      //左边发送信息的树形结构
      nodeClick (val) {
        var value=val
        this.isShow=1
        this.recipient=""
        this.myarr=[{
          'inputVal': ""
        }]
        if(value.id!='0000') {

          var str=val.content.replace(/\$\{([^}]+)\}/g,"___")
          var arr=str.split("___");
          this.mynewArrss=arr
          var myhtml=""
          arr.forEach((item,index) => {
            if(index==arr.length-1) {
              myhtml+=(item)
            } else {
              myhtml+=(item+`<input type="text" v-model="textarea" style="width:800px;border-color: transparent;box-shadow: inset 0 0;border-bottom-color: #1A1A1A;">`)
            }
          })
          this.contentHtml.innerHTML=myhtml
        }

        this.nowMidll=value

      },
      //切换消息记录
      getrecord () {
        this.isShow=2
        this.$refs['tree'].setCurrentKey(null);
      },
      //获取消息记录
      getrecordList () {
        var d={
          'pageIndex': this.pageIndex,
          'pageSize': this.pageSize,
          'phone': this.myphone,
          'unitId': this.unitId.id,
        }
        this.loading=true
        magsFindMagsRecord(d).then(res => {
          if(res.code==200) {
            this.tableData=res.data.content
            this.total=res.data.totalElements;
          }
          this.loading=false
        })

      },
      //分页
      handleSizeChange (val) {
        this.pageSize=val;
        this.getrecordList();
      },
      handleCurrentChange (val) {
        this.pageIndex=val;
        this.getrecordList();
      },
      //右边表格手机号
      handleSelectionChange (val) {
        if(this.recipient=="") {
          this.recipient+=val.phone
        } else {
          this.recipient+=","+val.phone
        }
        var str=JSON.parse(JSON.stringify(this.recipient));
        var elementToRemove=val.phone;

        if(str.includes(elementToRemove)) {
          var result=str.replace(new RegExp(elementToRemove+',','g'),'');
        }
        this.recipient=result



      },

      //发送短信
      savemessage () {


        var that=this


        const inputElement=this.contentHtml.querySelectorAll("input");
        var newstr=""
        inputElement.forEach(item => {
          newstr+=','+item.value
        })
        if(this.recipient=="") {
          this.$message({type: 'warning',message: '收件人不能为空！！！'});
          return
        }
        if(this.seccode.toUpperCase()!=this.codelist.toUpperCase()) {
          this.$message({type: 'error',message: '验证码错误！'})
          this.$refs.validCode.refreshCode();
          this.code()
          return
        };
        this.seccode=""
        this.$refs.validCode.refreshCode();
        this.code()
        var d={
          'parameters': newstr.substring(1),
          'phone': this.recipient,
          'templateCode': this.nowMidll.templateCode,
          'unitId': this.unitId.id,
        }
        var cestr=""
        this.mynewArrss.forEach(t => {
          cestr+=t
        })
        var myres=cestr+newstr.substring(1)

        this.btnFlag=true
        this.mysetInterval=setInterval(() => {
          that.mynum-=1
        },1000)
        if(myres.length>65) {
          // console.log("大于65个字节");
          this.$confirm('短信内容超过65个字节，确定要发送吗？','提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.savemessageApi(d)
          }).catch(() => {
            // ...
          });
        } else {
          this.savemessageApi(d)
        }

      },
      savemessageApi (val) {
        magssend(val).then(res => {

          if(res.code==200) {
            this.getPhone()
            this.$message({type: 'success',message: '发送成功'});
          } else {
            res.message? this.$message({type: 'error',message: `${res.message}`}):this.$message({type: 'error',message: '发送失败！！！！'})
          }
        })
      }
    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .textmessage {
    .mydisflex {
      display: flex;
      align-items: center;
    }

    /deep/.el-textarea__inner {
      height: 100%;
    }

    .myname {
      min-width: 56px !important;
      white-space: nowrap;
    }

    .mynamesss {
      display: flex;
      justify-content: space-between;
    }

    .divider-line {
      margin-top: 10px;
    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }

    .con {
      width: 100%;
      height: 100%;
      display: flex;

      .left-tree {
        width: 300px;
        height: 100%;
        padding: 12px 20px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .myrecordleft {
          width: 100%;
          height: 36px;
          display: flex;
          align-items: center;
          margin-top: 20px;
          cursor: pointer;

          &.myrecordleft-active {
            background-color: #D2EAFF;
          }

          img {
            margin-left: 25px;
            margin-right: 6px;
          }

          //  justify-content: center;
        }
      }

      .middle {
        width: calc(100% - 608px);
        height: 100%;
        padding: 12px 20px;
        box-sizing: border-box;
        background-color: #fff;

        .mysend {
          width: 100%;
          height: 100%;
        }

        .text {
          display: flex;
          width: 100%;
          height: 79%;
          margin-top: 20px;
        }

        .text-con {
          width: calc(100% - 56px);
          height: 100%;
          border: 1px solid #DCDFE6;
          padding: 12px;
          box-sizing: border-box;
          font-size: 16px;
        }

        .fasong {
          width: 100%;
          margin-top: 20px;
          display: flex;
          justify-content: flex-end;

        }
      }

      .middle2 {
        width: calc(100% - 308px);
        height: 100%;
        padding: 12px 20px;
        box-sizing: border-box;
        background-color: #fff;
      }

      .right-table {
        width: 300px;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        border-left: 2px solid #cccccc;
      }
    }
  }
</style>